import { TooltipPopOver } from '../TooltipPopOver'
import { ProgressBar } from 'react-bootstrap'
import { ProgressTooltip } from './ProgressTooltip'
import { formatNumber } from '@ztechapps/common.utils'

export type ProgressProps = {
  now: number
  max: number
  tooltipBody?: React.ReactNode
  variant?: 'success' | 'danger' | 'warning' | 'info' | 'primary' | 'secondary'
  height?: string
}
export const Progress = ({ now, max, height, variant, tooltipBody }: ProgressProps) => {
  max = max ?? 0
  now = now ?? 0
  const secondProgressNow = max - now
  const percentage = max > 0 ? now / max : 0
  const percentageString = formatNumber(percentage, '0%')

  variant = variant || 'success'
  tooltipBody = tooltipBody || <ProgressTooltip max={max} now={now} />

  return (
    <TooltipPopOver placement="auto" tooltipBody={tooltipBody}>
      <ProgressBar style={{ height }}>
        <ProgressBar
          label={percentage > 0 ? percentageString : undefined}
          variant={variant}
          now={now}
          max={max}
          key={1}
        />
        <ProgressBar variant={`${variant}-subtle`} now={secondProgressNow} max={max} key={2} />
      </ProgressBar>
    </TooltipPopOver>
  )
}
